module.exports = __webpack_public_path__ + "static/thirty-4-5d334d988ec98a0cba621b921f9a9011.png";